<template>
    <div class="pb-5" data-wizard-type="step-content"
         data-wizard-state="current">
        <div class="mb-10 font-weight-bold text-dark">Angaben überprüfen</div>
        <div class="row">
            <div class="col-md-6">
                <dl>
                    <dd>{{ __('user.email') }}</dd>
                    <dt>{{ formData.user.email || '-' }}</dt>
                </dl>
            </div>
            <div class="col-md-6">
                <dl>
                    <dd>{{ __('agency.agency') }}</dd>
                    <dt>{{ formData.agency.name }}</dt>
                </dl>
            </div>
        </div>
        <dl class="mt-3">
            <dd>{{ __('general.store') }}</dd>
            <dt v-show="!formData.store.store?.attributes.name">Keins</dt>
            <dt v-show="formData.store.store?.attributes.name">{{ formData.store.store?.attributes.name }}</dt>
            <dt v-show="formData.store.role?.name" class="text-muted">
                <i class="fas fa-user-lock mr-1"/>
                {{ formData.store.role?.name }}
            </dt>
        </dl>
    </div>
</template>

<script>
export default {
    props: {
        formData: Object
    }
}
</script>
